import { Link } from "react-router-dom";
import { Instagram, Mail, Heart } from "lucide-react";
import { useSite } from "../../contexts/SiteContext";

export default function Footer() {
    const { settings } = useSite();
    const brand = settings.brand || {};
    const footer = settings.footer || {};
    const contact = settings.contact || {};
    const nav = settings.nav_links || [];
    const pages = settings.footer_pages || [];

    return (
        <footer data-testid="site-footer" className="mt-32 border-t border-border-dim bg-obsidian">
            <div className="mx-auto max-w-[1480px] px-6 py-16 lg:px-12 lg:py-20">
                <div className="grid grid-cols-1 gap-10 md:grid-cols-4 md:gap-12">
                    <div className="md:col-span-2">
                        <div className="flex items-center gap-2">
                            {brand.logo_url ? (
                                <img src={brand.logo_url} alt={brand.name} className="h-9 w-auto object-contain" />
                            ) : (
                                <>
                                    <span className="relative inline-flex h-9 w-9 items-center justify-center rounded-full border border-gold">
                                        <span className="font-display text-base text-gold">{brand.logo_initial || "L"}</span>
                                        <span className="absolute -right-1 -top-1 text-heart">♥</span>
                                    </span>
                                    <span className="font-display text-2xl tracking-[0.15em] text-gold">
                                        {(brand.name || "LovinLife").toUpperCase()}
                                    </span>
                                </>
                            )}
                        </div>
                        {footer.blurb && (
                            <p className="mt-6 max-w-md font-display text-xl leading-tight text-white/90 sm:text-2xl">
                                {footer.blurb}
                            </p>
                        )}
                        <p className="mt-4 text-sm text-white/50">
                            Made with <Heart className="inline h-3 w-3 text-heart" /> in atelier 04.
                        </p>
                    </div>
                    <div>
                        <h4 className="text-[11px] uppercase tracking-[0.3em] text-gold">Shop</h4>
                        <ul className="mt-6 space-y-3 text-sm text-white/70">
                            {nav.map((l) => (
                                <li key={l.to}>
                                    <Link to={l.to} className="hover:text-gold">
                                        {l.label}
                                    </Link>
                                </li>
                            ))}
                        </ul>
                    </div>
                    <div>
                        <h4 className="text-[11px] uppercase tracking-[0.3em] text-gold">Atelier</h4>
                        <ul className="mt-6 space-y-3 text-sm text-white/70">
                            {pages.map((p) => (
                                <li key={p.slug}>
                                    <Link to={`/p/${p.slug}`} className="hover:text-gold">
                                        {p.label}
                                    </Link>
                                </li>
                            ))}
                            <li>
                                <Link to="/account" className="hover:text-gold">
                                    My account
                                </Link>
                            </li>
                            <li>
                                <Link to="/manual" className="hover:text-gold">
                                    User manual
                                </Link>
                            </li>
                            {contact.email && (
                                <li>
                                    <a href={`mailto:${contact.email}`} className="inline-flex items-center gap-2 hover:text-gold">
                                        <Mail className="h-3 w-3" /> {contact.email}
                                    </a>
                                </li>
                            )}
                            {contact.instagram && (
                                <li>
                                    <a
                                        href={contact.instagram_url || "#"}
                                        target="_blank"
                                        rel="noreferrer"
                                        className="inline-flex items-center gap-2 hover:text-gold"
                                    >
                                        <Instagram className="h-3 w-3" /> {contact.instagram}
                                    </a>
                                </li>
                            )}
                        </ul>
                    </div>
                </div>
                <div className="mt-16 flex flex-col items-start justify-between gap-4 border-t border-border-dim pt-8 text-xs text-white/40 md:flex-row md:items-center">
                    <p>
                        © {new Date().getFullYear()} {brand.name || "LovinLife"} Atelier. {footer.rights}
                    </p>
                    <p className="uppercase tracking-[0.3em]">{footer.tagline}</p>
                </div>
            </div>
        </footer>
    );
}
